import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { createMarkup } from '/Foundation/React/code/Utilities/HelperUtilities';
import { SIGNUP_SOURCE } from '../../../../../../AdobeAnalytics/code/Views/Feature/AdobeAnalytics/Constants/SignupSource.js';
import { AdobeAnalyticsUtil } from '/Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/AdobeAnalyticsUtil';
import { br_consentOptIn } from '/Foundation/Bloomreach/code/Events/BloomreachConsent';
import { setEmailCookie } from '/Foundation/Common/code/TrackingCookieApi';
import { br_isEnabled } from '/Foundation/Bloomreach/code/Events/Bloomreach.js';
import { shouldPreCheckInput } from '/Foundation/Common/code/Utils/Utils';
function Newsletter({ Newsletter }) {
  let input;
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [newsletterConsent, setNewsletterConsent] = useState(shouldPreCheckInput());
  return (
    br_isEnabled() && (
      <div className="newsletter-component">
        <div className="layout__content pt-0">
          <div className="thule-container">
            <div className="row py-14">
              <div className="col-lg-12">
                <div className="text-section text-center">
                  <h2
                    className="paragraph--s top-text mb-4"
                    dangerouslySetInnerHTML={createMarkup(Newsletter?.Text)}
                  ></h2>
                  <label
                    htmlFor="newsletter-email-input"
                    className="description heading3 mb-9"
                    dangerouslySetInnerHTML={createMarkup(Newsletter?.Description)}
                  ></label>
                </div>
              </div>
              <div className="col-lg-12">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setShowSuccessMessage(false);
                    const email = input.value;

                    // Set email cookie for tracking
                    setEmailCookie(email);

                    br_consentOptIn(email);

                    AdobeAnalyticsUtil.DataLayer.TrackEvent('newsletter_signup', {
                      newsletter: { variant: SIGNUP_SOURCE.FOOTER },
                    });

                    setShowSuccessMessage(true);

                    input.value = '';
                  }}
                >
                  <div className="d-flex">
                    <input
                      id="newsletter-email-input"
                      pattern={"[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}"}
                      title={Newsletter?.InvalidEmail}
                      placeholder={Newsletter?.EmailPlaceholder}
                      className="form-control newsletter-email-input paragraph--s rpa-newsletter-email-input"
                      required
                      ref={(node) => {
                        input = node;
                      }}
                    />
                    <button
                      id="newsletter-submit"
                      type="submit"
                      className="btn thule-btn-default-bg-dark signup-btn p-0 rpa-newsletter-submit"
                    >
                      <i className="le-icon-arrow rot-180"></i>
                      <span className="sr-only">Sign up to newsletter</span>
                    </button>
                  </div>
                  <div className="mt-5">
                    <label htmlFor="newsletter-privacy-checkbox" className="form-check-label">
                      <div className="form-check">
                        <input
                          id="newsletter-privacy-checkbox"
                          className="form-check-input rpa-newsletter-privacy-checkbox"
                          type="checkbox"
                          checked={newsletterConsent}
                          onChange={() => setNewsletterConsent(!newsletterConsent)}
                          title={Newsletter?.InvalidPrivacyPolicy}
                          required
                        />
                        <div
                          className="paragraph--s ms-4 pt-1"
                          dangerouslySetInnerHTML={createMarkup(Newsletter?.PrivacyPolicy)}
                        ></div>
                      </div>
                    </label>
                  </div>
                </form>
                {showSuccessMessage && (
                  <div id="newsletter-message" className="rpa-newsletter-message success message paragraph--s mt-4">
                    {Newsletter?.SuccessMessage}
                  </div>
                )}
              </div>
            </div>
            <hr className="my-0" />
          </div>
        </div>
      </div>
    )
  );
}

const root = createRoot(document.getElementById('REACT_newsletter'));
root.render(
  <Sentry.ErrorBoundary>
    <Newsletter {...window._THULEDATA._Footer} />
  </Sentry.ErrorBoundary>
);
